import { createSlice } from '@reduxjs/toolkit'

export const getInitialLanguage = () => {
    const stored = localStorage.getItem('activeLanguage');
    if (stored) return stored;

    const browserLang = navigator.language;

    return browserLang === 'tr-TR' ? 'tr' : 'eng';
};

const initialState = {
    value: getInitialLanguage(),
}
export const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setCurrentLanguage: (state: any, action) => {
            state.value = action.payload;
        }
    }
})

export const { setCurrentLanguage } = languageSlice.actions;

export default languageSlice.reducer;